import { create } from "zustand"

export interface ShareOptions {
    galleryId?: string
    eventImage?: string
    dialogText?: string
    hideDialog?: boolean
    speaker?: string
    expression?: string
}

interface ModalState {
    galleryOpen: boolean
    openGallery: () => void
    closeGallery: () => void

    shareOpen: boolean
    galleryId: string
    eventImage: string
    dialogText: string
    hideDialog: boolean
    speaker: string
    expression: string
    openShare: (options: ShareOptions) => void
    closeShare: () => void

    skinOpen: boolean
    openSkin: () => void
    closeSkin: () => void

    letterOpen: boolean
    openLetter: () => void
    closeLetter: () => void
}

export const useModalStore = create<ModalState>((set) => ({
    galleryOpen: false,
    openGallery: () => set({ galleryOpen: true }),
    closeGallery: () => set({ galleryOpen: false }),

    shareOpen: false,
    galleryId: "",
    eventImage: "",
    dialogText: "",
    hideDialog: false,
    speaker: "",
    expression: "",
    openShare: (options: ShareOptions) =>
        set({
            shareOpen: true,
            galleryId: options.galleryId ?? "",
            eventImage: options.eventImage ?? "",
            dialogText: options.dialogText ?? "",
            hideDialog: options.hideDialog ?? false,
            speaker: options.speaker ?? "",
            expression: options.expression ?? "",
        }),
    closeShare: () => set({ shareOpen: false }),

    skinOpen: false,
    openSkin: () => set({ skinOpen: true }),
    closeSkin: () => set({ skinOpen: false }),

    letterOpen: false,
    openLetter: () => set({ letterOpen: true }),
    closeLetter: () => set({ letterOpen: false }),
}))
